export const passwordOTP = {
  Back: 'Volver',
  'We sent a code to {{contact}}': 'Enviamos un código al {{contact}}',
  'Enter the verification code': 'Introduce el código de verificación',
  'Resend code at': 'Reenviar código a las',
  'Resend code': 'Reenviar código',
  'Change shipping method': 'Cambiar método de envío',
  'Code validated successfully!': '¡Código validado correctamente!',
};
